import styles from './Sidebar.module.css';

export interface NavItem {
  id: string;
  label: string;
  icon: string;
  badge?: number;
}

export interface NavGroup {
  label: string;
  items: NavItem[];
}

interface TenantBrand {
  companyName?: string;
  slug?: string;
}

interface UserInfo {
  name?: string;
  role?: string;
}

interface SidebarProps {
  groups: NavGroup[];
  activeId: string;
  onNavigate: (id: string) => void;
  brand?: TenantBrand;
  user?: UserInfo;
  onLogout?: () => void;
}

export function Sidebar({ groups, activeId, onNavigate, brand, user, onLogout }: SidebarProps) {
  const initial = brand?.companyName?.charAt(0) ?? '—';
  const displayName = user?.name ?? '—';
  const roleLabel: Record<string, string> = { tenant_owner: '管理者', tenant_manager: 'マネージャー', tenant_staff: 'スタッフ', super_admin: '管理者' };

  return (
    <aside className={styles.sidebar}>
      <div className={styles.brandBlock}>
        <div className={styles.brandRow}>
          <div className={styles.brandIcon}>{initial}</div>
          <div>
            <div className={styles.brandName}>{brand?.companyName ?? '—'}</div>
          </div>
        </div>
        {brand?.slug && (
          <div className={styles.tenantChip}>
            <span className={styles.chipDot} />
            {brand.slug}.jiayin.jp
          </div>
        )}
      </div>

      <nav className={styles.nav}>
        {groups.map((group) => (
          <div key={group.label} className={styles.navGroup}>
            <div className={styles.navLabel}>{group.label}</div>
            {group.items.map((item) => (
              <div
                key={item.id}
                className={`${styles.navItem} ${activeId === item.id ? styles.active : ''}`}
                onClick={() => onNavigate(item.id)}
              >
                <span className={styles.navIcon}>{item.icon}</span>
                <span>{item.label}</span>
                {item.badge != null && item.badge > 0 && (
                  <span className={styles.navBadge}>{item.badge}</span>
                )}
              </div>
            ))}
          </div>
        ))}
      </nav>

      <div className={styles.sidebarFoot}>
        <div className={styles.userRow}>
          <div className={styles.userAv}>{displayName.charAt(0)}</div>
          <div>
            <div className={styles.userName}>{displayName}</div>
            <div className={styles.userRole}>{roleLabel[user?.role ?? ''] ?? user?.role ?? '—'}</div>
          </div>
        </div>
        {onLogout && (
          <button className={styles.logoutBtn} onClick={onLogout}>ログアウト</button>
        )}
      </div>
    </aside>
  );
}
